export const navLinks = [
  { href: "#loesung", label: "Lösung" },
  { href: "#partner", label: "Partnerschulen" },
  { href: "#foerderung", label: "Förderung" },
  { href: "#kontakt", label: "Kontakt" },
  // { href: "#features", label: "Features" },
  // { href: "#newsletter", label: "Newsletter" },
]

export const formatPrice = (n) => `$${n.toFixed(2)}`
